import React from 'react';
import { TextField } from '@mui/material';
import { IKpiObjectiveContractSavePayload } from '../objectivecontract.models';
import SectionCard from '../components/SectionCard';

type Props = { data: IKpiObjectiveContractSavePayload; setContract: (patch: Partial<IKpiObjectiveContractSavePayload['contract']>) => void };
export default class MissionTab extends React.PureComponent<Props> { render() { const { data, setContract } = this.props; return <SectionCard title="II. Mission du Poste"><TextField fullWidth multiline minRows={8} label="Mission" value={data.contract.mission || ''} onChange={(e) => setContract({ mission: e.target.value })} /></SectionCard>; } }
